import React from 'react';
import { useLoader } from '.';


const Loader = () => {
  const { isLoading } = useLoader(); // Properly getting value from context

  return isLoading ? <div className="loader">Loading...</div> : null;
};

export default Loader;
